import { render, staticRenderFns } from "./UserSubscriptions.vue?vue&type=template&id=59f00e9a"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports